import React from 'react';
import { Modal, Upload, Button, Input, Radio, message, Spin } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group;
const dateFormat = "YYYY-MM-DD";
const Config = {
    apply:{
        title:'申请未签署合同关闭申请',
        url:API_URL.contract.closeNoSignedJdeApply,
        uploadType:'CLOSE',
    },
    approve:{
        title:'审批未签署合同关闭申请',
        url:API_URL.contract.approvalNoSignedCloseJdeApply,
        uploadType:'NO_SIGNED_CLOSE',
    },
    jdeApply:{
        title:'申请关闭JDE建号申请',
        url:API_URL.contract.closeJdeApply,
        uploadType:'CLOSE',
    },
    jdeApprove:{
        title:'审批JDE建号关闭申请',
        url:API_URL.contract.approvalCloseJdeApply,
        uploadType:'CONTRACT',
    },
}

class CloseJdeApply extends React.Component {
    state = {
        loading: false,
        visible: false,
        record: {},
        fileList: [],
        saveParams:{},
        type:'',
        config:{
            title:null,
            url:null,
        }
    }

    show = (record,type) => {
        this.setState({
            record,
            type,
            config: Config[type],
            visible: true,
        }, () => {
            if (type == 'jdeApprove'|| type == 'approve') {
                this.loadFileList(type);
            } 
        });
    }

    hide = () => {
        const { fileList, submit } = this.state;
        if(!submit){
            const { config } = this.state;
            if(config.uploadType == 'CLOSE'){
                fileList.forEach( file => {
                    this.handleRemove(file, false)
                })
            }
        }
        this.setState({
            fileList: [],
            visible: false,
            path: '',
            saveParams: {},
            submit:false,
        });
    }

    loadFileList = type => {
        const { record: { jdeApplyId } } = this.state;
        const options = {
            method: 'post',
            url: type == 'jdeApprove' ? API_URL.contract.queryJdeApplyCloseFileMeta : API_URL.contract.queryNoSignedJdeApplyCloseFileMeta,
            data: {
                jdeApplyId,
                uploadType: 'CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { fileList } = this.state;
                data.forEach((item, index) => {
                    const { name, id:fileMateId } = item;
                    fileList.push({
                        name,
                        response: { fileMetaId: fileMateId },
                        uid: index,
                    });
                });
                this.setState({ fileList });
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    submit = () => {
        const {
            record: {
                jdeApplyId
            },
            saveParams,
            fileList,
            type,
            config
        } = this.state;
        const {
            status,
            closeRemark,
            remark,
        } = saveParams  || {};
        let url;
        const params ={};
        if(type == 'jdeApply' || type == 'apply'){
            url = config.url;
            if (!closeRemark) {
                message.warning('请输入关闭原因');
                return;
            }
            if (!fileList.length) {
                message.warning('请上传附件');
                return;
            }
            (fileList || []).forEach((item, index) => {
                params[`ids[${index}]`] = item.response.fileMetaId;
            });
            params.jdeApplyId = jdeApplyId;
            params.closeRemark = closeRemark;
        } else if(type == 'jdeApprove' || type == 'approve'){
            url = config.url;
            if (!status) {
                message.warning('请选择审批结论');
                return;
            }
            if(status == 'INACTIVE' && !remark){
                message.warning('请填写拒绝原因');
                return;
            }
            params.status = status;
            if(status == 'INACTIVE')
            {
                params.remark = remark;
            }
            params.jdeApplyId = jdeApplyId;
        }
        this.sendServer(url, params);
    }

    sendServer = (url, params) => {
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url,
            data: {
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                if(success)
                {
                    message.success(success);
                    this.setState({
                        loading: false,
                        submit:true,
                    }, () => {
                        this.hide();
                        this.props.loadData();
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }


    handleInputChange = (e, key) => {
        const { saveParams } = this.state;   //record: { jdeApplyStatusShow }
        const value = e.target.value;
        if (key == 'status' && value == 'ACTIVE') {
            saveParams.remark = '';
        }
        saveParams[key] = e.target.value;
        this.setState({ saveParams });
    }

    handleDateChange = (value, key) => {
        let time = "";
        if (value) {
            time = value.format(dateFormat);
        }
        const { saveParams } = this.state;
        saveParams[key] = time;
        this.setState({ saveParams });
    }

    getDataList = () => {
        const {
            saveParams,
            record,
            fileList,
            path = '',
            type = '',
            config
        } = this.state;
        const {
            status,
            remark,
            closeRemark,
        } = saveParams || {};
        const {
            jdeApplyId,
            natureOfContractShow,
            jdeApplyCode,
            investigationName,
            investigationJdeCode,
            relationJdeCode,
            closeRemark:closeRemarkShow,
            noSignedCloseRemark,
        } = record;
        const { curRole } = sessionStorage;
        const jde = natureOfContractShow == '补充合同' ? '' : (natureOfContractShow == '终止合同' || natureOfContractShow == '终止函') ? relationJdeCode : investigationJdeCode;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <div>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">JDE建号申请编号</label>
                        <span className="ui-text">{jdeApplyCode}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">项目简称</label>
                        <span className="ui-text">{investigationName}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">JDE项目号</label>
                        <span className="ui-text">{jde}</span>
                    </div>
                </li>
                { // 关闭JDE建号申请
                    (type == 'jdeApply' || type == 'apply') && 
                    <div>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">{asterisk}关闭原因</label>
                                <span className="ui-text">
                                    <Input
                                        placeholder="请输入"
                                        style={{width: 182}}
                                        value={closeRemark}
                                        onChange={e => this.handleInputChange(e, 'closeRemark')}
                                    />
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">{asterisk}上传相关凭证</label>
                                <span className="ui-text">
                                    <Upload
                                        action={API_URL.contract.uploadJdeApplyEnclosure}
                                        data={{
                                            path,
                                            jdeApplyId,
                                            uploadType: config.uploadType,
                                            curUserId: sessionStorage.userId,
                                            curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        }}
                                        beforeUpload={this.beforeUpload}
                                        onChange={this.handleChange}
                                        onRemove={this.handleRemove}
                                        fileList={fileList}
                                        headers={xToken}
                                    >
                                        <Button style={{ width: 80 }}>上传附件</Button>
                                    </Upload>
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label clearAfter"></label>
                                <span className="ui-text" style ={{color:'red'}}>
                                    请提供确定无法签署合同的结论附件
                                </span>
                            </div>
                        </li>
                    </div>
                }
                { // 审批关闭申请
                    (type == 'jdeApprove' || type == 'approve') &&
                    <div>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">关闭原因</label>
                                <span className="ui-text">
                                    {type == 'jdeApprove' ? closeRemarkShow : noSignedCloseRemark}
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">相关凭证</label>
                                <span className="ui-text">
                                    {
                                        fileList.map(i => <a onClick={e => this.downLoadFile(e, i.response.fileMetaId)}>{i.name}<br /></a>)
                                    }
                                </span>
                            </div>
                        </li>
                        <hr style={{ margin: '10px 0' }} />
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">{asterisk}审批结论</label>
                                <span className="ui-text" style={{ width: 420 }}>
                                    <RadioGroup onChange={e => this.handleInputChange(e, 'status')} value={status}>
                                        <Radio value='ACTIVE'>同意</Radio>
                                        <Radio value='INACTIVE'>拒绝</Radio>
                                    </RadioGroup>
                                </span>
                            </div>
                        </li>
                        {
                            status == 'INACTIVE' &&
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label clearAfter"></label>
                                    <span className="ui-text">
                                        <Input
                                            placeholder="请填写拒绝原因（必填）"
                                            style={{width: 240}}
                                            value={remark}
                                            onChange={e => this.handleInputChange(e, 'remark')} 
                                        />
                                    </span>
                                </div>
                            </li>
                        }
                        {
                            curRole != 'VP' && type == 'jdeApprove' && 
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label clearAfter"></label>
                                    <span className="ui-text" style ={{color:'red'}}>
                                    注：项目关闭前，请完成所有收尾工作。关闭申请审核通过后，项目数据不再可编辑
                                    </span>
                                </div>
                            </li>
                        }
                </div>
                }
            </div>
        )
    }

    beforeUpload = file => {
        const { fileList = [] } = this.state;
        const isLt30M = file.size / 1024 / 1024 <=30;
        if (fileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    handleChange = ({ file, fileList }) => {
        if (file.status == "done") {
            if (file.response.error) {
                message.error(file.response.error);
                file.status = 'removed';
                const fileData = [...this.state.fileList];
                const index = fileData.indexOf(file);
                fileList.splice(index, 1);
            } else if (file.response.success) {
                message.success('上传附件成功');
            }
        }
        this.setState({ fileList });
    }

    handleRemove = (file, message = true) => {
        const options = {
            method: 'POST',
            url: API_URL.contract.deleteJdeCodeEnclosure,
            data: {
                fileMetaId: file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.error) {
                    message && message.error(res.error);
                } else {
                    message && message.success(res.success);
                }
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, type, config } = this.state;
        return (
            <Modal
                title={ config.title }
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="720px"
            >
                <div className="cont-cont" style={{ padding: '0 20px' }}>
                    <Spin spinning={loading}>
                        <ul className="preview-list apply-jde">
                            {this.getDataList()}
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )
    }
}

export default CloseJdeApply;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/CloseJdeApply.js